import React, { useState } from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  webmPlayerContainer: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
  },
  webmPlayer: {
    width: "100%",
    height: "auto",
  },
});

function WebmPlayer({ src }) {
  const classes = useStyles();
  const [error, setError] = useState(false);

  const handleVideoError = () => {
    setError(true);
  };

  return (
    <div className={classes.webmPlayerContainer}>
      {error ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          Video will be available soon. Visit this page again.
        </div>
      ) : (
        <video
          className={classes.webmPlayer}
          controls
          onError={handleVideoError}
        >
          <source src={src} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
}

export default WebmPlayer;
